const URL = import.meta.env.VITE_GOOGLE_OAUTH_RETURN_URL

export default function GetReturnURL(): string {
  let url: string = URL
  if (!url.startsWith('http') && !url.startsWith('https')) {
    url = 'http://' + url
  }

  return url
}